import React, {useState, useEffect} from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

const Styles = styled.div``;

const SelectNivelAdmTicket = ({id, value, onChange, isInvalid, isClearable,subTipoTicket,isDisabled}) => {
    const [items, setItems] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState();
    const nivelAdmTk = useSelector(state => state.default.nivelAdmTk);

    const onSelectValue = (ev) => {
        setSelectedValue(ev);
        onChange(ev);
    };

    useEffect(() => {
        setItems(nivelAdmTk);
    }, [nivelAdmTk]);

    useEffect(() => {
        let filtro = items;
        if(subTipoTicket){
            filtro = items.filter((it)=>it.subTipoId_natk === subTipoTicket)
        }
        const newOptions = filtro.map((item) => {
            return {
                value: item.id_natk,
                label: item.nombre_natk
            };
        });
        setOptions(newOptions);
        if (typeof value === 'string' || typeof value === 'number') {
            setSelectedValue(
                newOptions.find((opt) => opt.value === Number(value))
            );
        } else if(Array.isArray(value)){
            setSelectedValue(value.map(va=>({label:va.nombre_natk,value:va.id_natk})));
        }else{
            setSelectedValue(null);
        }
    }, [items,subTipoTicket,value])
    return (
        <Styles>
            <Select
                inputId={id}
                className={`react-select-container ${
                    isInvalid ? 'is-invalid' : ''
                }`}
                styles={{menuPortal: (base) => ({...base, zIndex: 9999})}}
                menuPortalTarget={document.body}
                classNamePrefix="react-select"
                placeholder="Seleccione..."
                options={options}
                value={selectedValue}
                onChange={onSelectValue}
                isClearable={isClearable}
                isDisabled={isDisabled}
            />
        </Styles>
    );
};

SelectNivelAdmTicket.defaultProps = {
    isClearable: false
};

export default SelectNivelAdmTicket;
